import makeHttpRequest from '../helpers/ajax';

const getDailyMortgageRates = (product, crditRange, loanProgramType) => {
    const errorResponse = {};
    const loanProgram = loanProgramType === '' ? 'conventional' : loanProgramType;

    if (!product || !crditRange) {
        return errorResponse;
    }

    let url = `${WP_FINANCIAL_API_URL}/api/interestrates/average`;
    url += `?product=${product.toLowerCase()}`;
    url += `&creditRange=${crditRange}`;
    url += `&loanProgramType=${loanProgram.toLowerCase()}`;

    const request = {
        url, storage_key: `${product}_${crditRange}_${loanProgram}_trend`,
    };

    return makeHttpRequest(request).then((response) => {
        const trendResult = JSON.parse(response);
        if (trendResult.result && Number(trendResult.statusCode) === 200) return trendResult.result;
        return {};
    }, (error) => {
        console.warn(`There is some issue with network call for lender reviews, please try again ${error}`);
        return errorResponse;
    });
};

export default {
    getDailyMortgageRates,
};
